import axios from 'axios';

export enum EmploymentType {
    Permanent = 'Permanent',
    Intern = 'Intern',
    Freelance = 'Freelance',
}

export interface Employee {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    employmentType: EmploymentType;
    employmentDate: string;
}

export class EmployeeService {
    /*private static API_URL = `${process.env.VUE_APP_API_BASE_URL}api/employee`;*/
    private static API_URL = 'https://mobiz-demo.azurewebsites.net/api/employee';

    public static async getEmployees(): Promise<Employee[]> {
        const response = await axios.get(`${this.API_URL}/readall`);
        return response.data;
    }

    public static async addEmployee(employee: Employee): Promise<Employee> {
        const response = await axios.post(this.API_URL, employee);
        return response.data;
    }

    public static async updateEmployee(employee: Employee): Promise<Employee> {
        const response = await axios.post(this.API_URL, employee);
        return response.data;
    }
}
